/**
 * Open autonmatically the accordion if the url comes with a hash
 */
export default function setAccordionActive() {
    const accordionParent = document.querySelector('.wrap-program-accordions');
    if (!accordionParent) return;

    // Get the hash from the url
    const hash = window.location.hash;

    // Open the accordion if the hash exists, or the first accordion if not
    const accordionItem = hash
        ? accordionParent.querySelector(hash)
        : accordionParent.querySelector('.accordion-item');

    // in case the hash is an another section of the page that doesn't belong to the accordions
    if(!accordionItem) return;
    const accordionButton = accordionItem.querySelector('.accordion-button');
    const accordionBody = accordionItem.querySelector('.accordion-collapse');

    // Open the accordion
    accordionBody.classList.add('show');
    accordionButton.classList.remove('collapsed');
}
